exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__container___24ca7{max-width:600px;margin:20px auto}.style__success___OkFTo{text-align:center;margin-top:30px}", ""]);

// exports
exports.locals = {
	"container": "style__container___24ca7",
	"success": "style__success___OkFTo"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/client-form/style.css
// module id = 678
// module chunks = 0